import React, { Component } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
} from '@material-ui/core';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import TableActionButton from './ActionButtons/TableActionButton';
import IconsButton from '../../shared/Buttons/IconsButton';

const styles = (theme) => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 600,
    fontSize: '1.2rem',
  },
  buttonGroup: {
    display: 'flex',
    gap: theme.spacing(2),
  },
  tableHead: {
    backgroundColor: '#EAE8ED',
    borderBottom: '1px solid rgba(35, 31, 41, 0.16)',
    color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 500,
    fontSize: '0.875rem',
  },
  tableCell: {
    borderBottom: '1px solid rgba(35, 31, 41, 0.16)',
  },
  chip: {
    background: 'rgba(35, 31, 41, 0.08)',
    borderRadius: '100px',
    padding: '7px 14px',
    display: 'inline-block',
    fontSize: '0.8125rem',
    fontWeight: 400,
    color: 'rgba(0, 0, 0, 0.87)',
  },
  text: {
    fontSize: '0.875rem',
    fontWeight: 500,
    color: 'rgba(0, 0, 0, 0.87)',
  },
});

const truncate = (text: string, maxLength = 40): string =>
  text.length > maxLength ? `${text.slice(0, maxLength - 3)}...` : text;

const downArrowIconStyle = {
  transform: 'scale(0.9)',
  marginTop: '-2px',
};

const upwardArrowIconStyle = {
  transform: 'scale(0.9) rotateX(-180deg)',
  marginTop: '-2px',
};

class RolesTable extends Component<any> {
  state = {
    sortColumn: 'name',
    sortOrder: 'ASC',
  };

  handleSortColumn = (columnName) => {
    if (this.state.sortColumn === columnName) {
      if (this.state.sortOrder === 'ASC') {
        this.setState({
          ...this.state,
          sortOrder: 'DESC',
        });
      } else {
        this.setState({
          ...this.state,
          sortOrder: 'ASC',
        });
      }
    } else {
      this.setState({ sortColumn: columnName, sortOrder: 'ASC' });
    }
  };

  sortData = () => {
    // Ensure roles is an array and create a copy to avoid mutating original
    const roles = Array.isArray(this.props.roles) ? [...this.props.roles] : [];

    return roles.sort((a, b) => {
      if (this.state.sortOrder === 'ASC') {
        return typeof a[this.state.sortColumn] === 'string'
          ? a[this.state.sortColumn].localeCompare(b[this.state.sortColumn])
          : a[this.state.sortColumn] - b[this.state.sortColumn];
      } else {
        return typeof a[this.state.sortColumn] === 'string'
          ? b[this.state.sortColumn].localeCompare(a[this.state.sortColumn])
          : b[this.state.sortColumn] - a[this.state.sortColumn];
      }
    });
  };

  renderIconButton = (columnName) => (
    <IconsButton
      size={'small'}
      icon={ArrowDownwardIcon}
      style={
        columnName === this.state.sortColumn && this.state.sortOrder === 'DESC'
          ? upwardArrowIconStyle
          : downArrowIconStyle
      }
      handleClick={() => this.handleSortColumn(columnName)}
    />
  );

  render() {
    const { classes, history } = this.props;
    const roles = this.sortData();

    const handleRowClick = (rowId) => {
      if (history && history.push) {
        history.push(`/viewRole/${rowId}`);
      }
    };

    return (
      <Box>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell className={classes.tableHead}>
                  Role
                  {this.renderIconButton('name')}
                </TableCell>
                <TableCell className={classes.tableHead}>
                  Users
                  {this.renderIconButton('userCount')}
                </TableCell>
                <TableCell className={classes.tableHead}>
                  Permission
                  {this.renderIconButton('permissionsCount')}
                </TableCell>
                <TableCell className={classes.tableHead}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {roles && roles.length > 0 ? (
                roles.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell
                      style={{ cursor: 'pointer' }}
                      onClick={() => handleRowClick(row.id)}
                      className={classes.tableCell}
                    >
                      <span className={classes.text}>
                        {truncate(row.name, 40)}
                      </span>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <span className={classes.chip}>{row.userCount}</span>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <span className={classes.chip}>
                        {row.permissionsCount === this?.props?.totalPermissions
                          ? 'All Access'
                          : row.permissionsCount}
                      </span>
                    </TableCell>
                    <TableCell className={classes.tableCell} align="center">
                      <TableActionButton data={row} />
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={4}
                    align="center"
                    className={classes.tableCell}
                  >
                    <span className={classes.text}>No roles found</span>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  }
}

export default withStyles(styles as any, { withTheme: true })(
  withRouter(RolesTable),
);
